<template> 
    <div class="nav n-open">
      <div class="bt-close" @click="closeMobileSidebar"></div>
      <router-link :key="$store.state.menu.id" to="/" >
        <div class="nav-title"><svg-icon iconName="pms" /> 
          <span v-if="isCollapse"></span>
          <span v-else>{{ $t('Title')}}</span> 
        </div>
      </router-link>
      <el-menu
          class="el-menu-vertical-demo"
          mode="vertical"
          background-color="#2B495A"
          text-color="#fff"
          active-text-color="#ffb980"
          :default-active="$router.currentRoute.name"
          :collapse-transition="false"
      >
          <MenuTree :menuData="$store.state.menu"></MenuTree>
      </el-menu>
   </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuTree from './MenuTree.vue'
export default {
    name: 'Sidebar',
    components: {
      MenuTree
    },
    created() {
      this.$store.dispatch("getMenuByCurrentAccount")
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ]),
      isCollapse() {
        return !this.sidebar.open
      }
    },
    methods: {
      closeMobileSidebar() {
        this.sidebar.open = !this.sidebar.open;
      }
    },
 }

</script>

<style>
  /* .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  } */
  /* .el-scrollbar {
        height: 100%;
    } */
</style>